module.exports = __webpack_public_path__ + "img/function_meet.05a5ff2a.png";